import React, { useEffect, useState } from 'react';
import { PaginationKaBaap, SettlementModal } from '../Common';
import { Button, Icon } from 'antd';
import { connect } from 'react-redux';
import { goTo, generate_query_set, handleApiExceptions, alertify } from '../../app_methods';
import { EaseTable } from '../../libs/EaseTable';
import { getVirtualAccountTableColumns, virtualAccountFilterNodes } from './constants';
import { isMobile } from 'react-device-detect';
import { VirtualAccountModal, SendCollectRequestModal } from '../Common';
import { VirtualAccountDetailsDrawer } from './virtual_account_details_drawer';
import { VirtualAccount, SmartCollectDisbursements } from '../../models';
import { VirtualAccountInsightsDrawer } from './insights_drawer';
import { toggleVirtualAccountModalAction, updateCurrentUserAction } from '../../redux/actions';
import { MerchantService } from '../../services';
import { PermissionHoc } from '../HOC';
import FileSaver from 'file-saver';
import { ConfigureSplitAccountModal } from "../Settings/InstaCollect/SplitAccountConfigurationModal";


const VirtualAccountsComponent = (props) => {
    const [isTableLoading, setIsTableLoading] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [isSaving, setIsSaving] = React.useState(false);
    const [filters, setFilters] = React.useState({});
    const [activeVA, setActiveVA] = React.useState({});
    const [showCollectRequestModal, setShowCollectRequestModal] = React.useState(false);
    const [showDetailsDrawer, setShowDetailsDrawer] = React.useState(false);
    const [virtualAccounts, setVirtualAccounts] = React.useState([]);
    const [showInsightsDrawer, setShowInsightsDrawer] = React.useState(false);
    const [settlementAccounts, setSettlementAccounts] = useState([]);
    const [showSettlementModal, setShowSettlementModal] = useState(false);
    const [showSplitConfigureModal, setShowSplitConfigureModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    const toggleSettlementModal = (data = {}) => {
        setActiveVA(data);
        setShowSettlementModal(!showSettlementModal);
    }
    
    const togglesplitModal = (data = {}) => {
      setActiveVA(data);
      setShowSplitConfigureModal(!showSplitConfigureModal);
    };

    const toggleVirtualAccountModal = (data = {}) => {
        setActiveVA(data);
        props.toggleVirtualAccountModal();
    }

    const toggleCollectRequestModal = (data = {}) => {
        setActiveVA(data);
        setShowCollectRequestModal(!showCollectRequestModal);
    }

    const toggleDetailsDrawer = (data = {}) => {
        setActiveVA(data);
        setShowDetailsDrawer(!showDetailsDrawer)
    }

    const showVATransactions = (data) => {
        props.onTabRender("transactions");
        if (data.is_submerchant){
            goTo(`/insta-collect/virtual-accounts/${data.merchant}/${data.id}/transactions`, props.history, {"id": data.id, "merchant": data.merchant })
        } else{
            goTo(`/insta-collect/virtual-accounts/${data.id}/transactions`, props.history, { "account_number": data.virtual_account_number, "id": data.id})
        }
    }

    const toggleInsightsDrawer = (data) => {
        setActiveVA(data);
        setShowInsightsDrawer(!showInsightsDrawer);
    }

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchSettlementAccounts = async () => {
        if (!props.current_user.key) return;
        const response = await SmartCollectDisbursements.account_list({});
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        setSettlementAccounts(response.data);
    };

    const settleAmount = async (data) => {
        if (!props.current_user.key) return;
        setLoading(true);
        const response = await SmartCollectDisbursements.initiate_settlements(data);
        if (!response.success) {
            setLoading(false);
            handleApiExceptions(response);
            return;
        }
        toggleSettlementModal();
        fetchMerchantInfo();
        alertify("Success", `Payment settled successfully`, "success");
        setLoading(false);
    }


    const updateStatus = async (data = {}) => {
        setActiveVA(data);
        const virtual_account = new VirtualAccount(data);
        const response = await virtual_account.update_status({ "is_active": !data.is_active })
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        fetchVirtualAccounts({ ...pagination }, { ...filters });
        alertify("Success", `Virtual Account status updated successfully.`, "success");
    }

    const sendCollectRequest = async (data = {}) => {
        setIsSaving(true);
        const virtual_account = new VirtualAccount(activeVA);
        const response = await virtual_account.send_collect_request(data);

        setIsSaving(false);

        if (!response.success) {
            const message = response.message || response.data?.message || "";

            if (
                !message.includes("is fixed for this VPA") &&
                !message.includes("Minimum UPI Limit")
            ) {
                toggleDetailsDrawer();
                toggleCollectRequestModal();
            }
            handleApiExceptions(response);
            return;
        }

        toggleCollectRequestModal();
        toggleDetailsDrawer();
        alertify("Success", "Collect request sent successfully.", "success");
    };


    const tableColumns = getVirtualAccountTableColumns(props.current_user.ecvabm, {
      toggleSettlementModal,
      showVATransactions,
      toggleVirtualAccountModal,
      toggleDetailsDrawer,
      updateStatus,
      toggleInsightsDrawer,
      togglesplitModal,
    });

    const fetchVirtualAccounts = async (_pagination, _filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await VirtualAccount.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ..._filters });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let virtual_accounts = generate_query_set(VirtualAccount, response.data.results)
        virtual_accounts = virtual_accounts.map((account) => { return { ...account, is_submerchant:!!_filters.submerchant_id }})
        setVirtualAccounts(virtual_accounts);
        setPagination({  ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        const response = await VirtualAccount.report_download({ ...prepFilters(filters) });
        if (response.status != 200) {
            setIsDownloading(false);
            handleApiExceptions("Something went wrong !");
            return;
        }
        FileSaver.saveAs(response.data, `Insta Collect Virtual Accounts.csv`);
        setIsDownloading(false);
    };

    const saveVirtualAccount = async (data) => {
        const payload = {
            label: data.label,
            description: data.description ? data.description : '',
            auto_deactivate_at: data.auto_deactivate_at ? data.auto_deactivate_at.format('YYYY-MM-DD') : '',
            authorized_remitters: data.remitters ? data.remitters : [],
            virtual_account_number: data.virtual_account_number,
            virtual_payment_address: data.virtual_payment_address,
            id: data.id,
            phone_numbers: data.phone_numbers,
            transaction_amount_limit: {
                "upi": data.upi_transfer_limit,
                "upi_fixed": data.upi_fixed_transfer_limit,
                "imps": data.imps_transfer_limit,
                "neft": data.neft_transfer_limit,
                "rtgs": data.rtgs_transfer_limit
            },
            unique_request_number: data.unique_request_number,
            udf1: data.udf1,
            udf2: data.udf2,
            udf3: data.udf3,
            udf4: data.udf4,
            udf5: data.udf5,
        }
        setIsSaving(true);
        const virtual_account = new VirtualAccount(payload);
        const response = await virtual_account.save();
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        toggleVirtualAccountModal();
        if (!activeVA.is_edit) fetchMerchantInfo();
        alertify("Success", `Virtual Account ${activeVA.is_edit ? "updated" : "created"} successfully.`, "success");
        setIsSaving(false);
        fetchVirtualAccounts(pagination, filters);
    }

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchVirtualAccounts(_pagination, tableInfo.filters);
    };

    const tableFilters = virtualAccountFilterNodes(props.current_user);

    const initActionButton = () => {
        const btn = props.actionRef.current;
        if (btn){
            const btnProps = { ...btn.props, onClick: () => toggleVirtualAccountModal() }
            btn.props = { ...btnProps };
        }
    }

    useEffect(() => {
        props.onTabRender('virtual_accounts');
        fetchSettlementAccounts();
        fetchVirtualAccounts({ ...pagination }, { ...filters });
        setTimeout(() => {
            initActionButton();
        }, 1000);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            initActionButton();
        }, 1000);
    }, [props.showVirtualAccountModal]);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchVirtualAccounts({ ..._pagination }, filters);
    };

    return (
        <div>
            <EaseTable
                rowKey="id"
                loading={isTableLoading}
                data={virtualAccounts}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                handleTableChange={handleTableChange}
                // pagination={pagination}
                // totalRecords={pagination.total}
                filterNodes={tableFilters}
                downloadable={true}
                onDownload={downloadReport}
                isDownloading={isDownloading}
            /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />

            <VirtualAccountModal
                visible={props.showVirtualAccountModal}
                toggleVirtualAccountModal={toggleVirtualAccountModal}
                virtualAccount={activeVA}
                onSubmit={saveVirtualAccount}
                loading={isSaving}
            />

            <SendCollectRequestModal
                visible={showCollectRequestModal}
                toggleCollectRequestModal={toggleCollectRequestModal}
                virtualAccount={activeVA}
                onSubmit={sendCollectRequest}
                loading={isSaving}
            />

            <VirtualAccountDetailsDrawer
                visible={showDetailsDrawer}
                toggleDetailsDrawer={toggleDetailsDrawer}
                toggleCollectRequestModal={toggleCollectRequestModal}
                virtualAccount={activeVA}
                current_user={props.current_user}
            />
            <VirtualAccountInsightsDrawer
                visible={showInsightsDrawer}
                toggleInsightsDrawer={toggleInsightsDrawer}
                va={activeVA}
            />
            <SettlementModal
                visible={showSettlementModal}
                toggleSettlementModal={toggleSettlementModal}
                settlementAccounts={settlementAccounts}
                onSubmit={settleAmount}
                loading={loading}
                virtualAccount={activeVA}
                settlementEnabled={props.current_user.mse}
                settlement_payment_modes={props.current_user.settlement_payment_modes}
            />
            {props.current_user?.split_settlement_type === "CVA" && props.current_user?.ess ? (
              <ConfigureSplitAccountModal
                visible={showSplitConfigureModal}
                onCancel={togglesplitModal}
                merchantId={props.current_user.id}
                split_settlement_type={props.current_user?.split_settlement_type}
                cva_id={activeVA?.id}
                virtualAccount={activeVA}
                toggleConfigureModal={togglesplitModal}
              />
            ) : null}
        </div>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user,
    showVirtualAccountModal: state.uiReducer.showVirtualAccountModal,
})

const mapDispatchToProps = dispatch => ({
	updateCurrentUser: user => dispatch(updateCurrentUserAction(user)),
    toggleVirtualAccountModal: () => dispatch(toggleVirtualAccountModalAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(VirtualAccountsComponent, 'IC_CVA_READ'));
